// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b379ee58","453":"5e0c95fb"}[chunkId] + ".chunk.js";
};